export const COLORS = {
  black: '#000',
  blue: '#2b9ab8',
  'dark-green': '#2A8806',
  'dark-grey': '#777770',
  green: '#2A8806',
  grey: '#cccccc',
  info: '#3FA2F7',
  'light-grey': '#eee',
  'light-saffron': '#fff1c2',
  'med-grey': '#ccc',
  orange: '#f69c05',
  red: '#d2232a',
  saffron: '#f3c03f',
  'tci-black': '#3c3c3c',
  'tci-purple': '#522e91',
  'teal-blue': '#247f99',
  'very-dark-grey': '#555',
  white: '#ffffff',
};
